import { createRouter, createMemoryHistory } from "vue-router";
import HomePage from "@/ui/admin/home/HomePage.vue";
import TestimonialHome from "@/ui/admin/testimonials/TestimonialHome.vue";
import SettingsHome from "@/ui/admin/settings/SettingsHome.vue";
import LoginPage from "@/ui/admin/settings/LoginPage.vue";

// Define routes
const routes = [
    { path: "/", component: TestimonialHome },
    { path: "/settings", name: "settings", component: SettingsHome },
];

// Create router instance
const adminRouter = createRouter({
    history: createMemoryHistory("home"),
    routes, // Set up the routes
});

adminRouter.beforeEach((to, from, next) => {
    next();
});
export default adminRouter;
